import { ActivityFlags } from "./ActivityFlags";
import { ValueGetters } from "../utils/StatisticsValueGetters";

export const StatisticsGridConfig = {
    columnDefs: [
        {
            field: 'invited',
            headerName: 'Invited',
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            colId: 'date',
            field: 'date',
            headerName: 'ISODate',
            width: 230,
            hide: true,
        },
        {
            colId: 'nyDate',
            field: 'nyDate',
            headerName: 'NY Date',
            width: 230,
            valueGetter: ValueGetters.newYorkTimeValueGetter,
            valueFormatter: ValueGetters.newYorkTimeValueFormatter,
        },
        {
            field: 'opSystem',
            headerName: 'OS',
            valueGetter: ValueGetters.opSysFromResponse,
            filter: 'agMultiColumnFilter',
            width: 150,
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: 'browser',
            headerName: 'Browser',
            valueGetter: ValueGetters.simplifiedBrowser,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            },
        },
        {
            field: 'device',
            headerName: 'Detail',
            hide: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            },
        },
        {
            field: 'orientation',
            headerName: 'Orientation',
            valueGetter: ValueGetters.orientation,
            width: 120,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            },
        },
        {
            field: 'city',
            headerName: 'City',
            valueGetter: ValueGetters.sourceIpToLocation('city'),
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: 'region',
            headerName: 'Region',
            valueGetter: ValueGetters.sourceIpToLocation('regionName'),
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: 'country',
            headerName: 'Country',
            valueGetter: ValueGetters.sourceIpToLocation('country'),
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: 'service',
            headerName: 'Service',
            valueGetter: ValueGetters.sourceIpToLocation('isp'),
            width: 250,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: 'timeSpent',
            headerName: 'Time Spent',
            valueGetter: ValueGetters.timeSpent,
        },
        {
            field: ActivityFlags.renewPassportLinkClicked,
            headerName: 'Passport',
            valueGetter: ValueGetters.isPresentValueFormatter,
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: ActivityFlags.shangrilaLinkClicked,
            headerName: 'Hotel',
            valueGetter: ValueGetters.isPresentValueFormatter,
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            }
        },
        {
            field: ActivityFlags.visaLinkClicked,
            headerName: 'Visa',
            valueGetter: ValueGetters.isPresentValueFormatter,
            width: 150,
            filter: 'agMultiColumnFilter',
            filterParams: {
                buttons: ['clear'],
            },
        },
    ]
}